<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-' + item.ID">
                <td>{{ item.Name }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, PRICES_STATUS_LIST)}">{{ item.Status | display_value(PRICES_STATUS_LIST) }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Global, PRICES_GLOBAL_LIST)}">{{ item.Global | display_value(PRICES_GLOBAL_LIST) }}</td>
                <td>{{ (item.ModifiedDate || item.CreatedDate) | display_date }}</td>
                <td>{{ item.ModifiedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">fa-edit</v-icon>
                  <v-icon medium class="mr-2" @click="copyDetail(item.ID)">fa-copy</v-icon>
                  <v-icon medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogLogView" persistent max-width="1200px">
      <v-card>
          <v-card-title>
              <span class="title">Nhật ký bảng giá</span>
          </v-card-title>
          <v-card-text>
              <v-layout row wrap pa-3>
                <v-flex lg12>
                  <v-data-table :headers="log_headers" :items="log_items" :options.sync="log_pagination" :server-items-length="log_total_rows" :footer-props="items_per_page" :must-sort="false" :loading="log_loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>{{ item.Action }}</td>
                        <td>{{ item.Username }}</td>
                        <td>{{ item.PriceName }}</td>
                        <td>{{ item.ChinaStoreName }}</td>
                        <td>{{ item.VietnamStoreName }}</td>
                        <td class="text-end">{{ item.WeightMin | currency('', 2)}}</td>
                        <td class="text-end">{{ item.WeightMax | currency('', 2)}}</td>
                        <td class="text-end">{{ item.Amount | currency }}</td>
                        <td>{{ item.CreatedDate | display_date}}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogLogView = false">Đóng</v-btn>
          </v-card-actions>
        </v-card>
  </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Bảng giá",
          value: "Name",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PRICES_STATUS_LIST,
          dataType: dataType["Enum"],
        },
        {
          text: "Phân loại",
          value: "Global",
          filterable: true,
          values: configs.PRICES_GLOBAL_LIST,
          dataType: dataType["Enum"],
        },
        {
          text: "Ngày sửa",
          value: "ModifiedDate",
          filterable: true,
          dataType: dataType["Date"],
        },
        {
          text: "Người sửa",
          value: "ModifiedBy",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      log_headers: [
        {
          text: "Hành động",
          value: "Action",
          sortable: false,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Người xóa",
          value: "Username",
          sortable: false,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Bảng giá",
          value: "PriceName",
          sortable: false,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Kho TQ",
          value: "ChinaStoreName",
          sortable: false,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Kho VN",
          value: "VietnamStoreName",
          sortable: false,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Min",
          value: "WeightMin",
          sortable: false,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Max",
          value: "WeightMax",
          sortable: false,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Giá",
          value: "Amount",
          sortable: false,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ngày xóa",
          value: "CreatedDate",
          sortable: false,
          dataType: configs.DATA_TYPE["Date"]
        }
      ],
      PRICES_GLOBAL_LIST: configs.PRICES_GLOBAL_LIST,
      PRICES_STATUS_LIST: configs.PRICES_STATUS_LIST,
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      log_pagination: {
        ...configs.PAGINATION,
        sortBy: ["CreatedDate"]
      },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "prices_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
      dialogLogView: false
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    }
  },
  computed: mapState({
    items: (state) => state.prices.all.data,
    total_rows: (state) => state.prices.all.total,
    loading: (state) => state.prices.loading,
    log_items: state => state.priceLog.all.data,
    log_total_rows: state => state.priceLog.all.total,
    log_loading: state => state.priceLog.loading
  }),
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
      };
      this.$store.dispatch("prices/getList", param);
    },
    copyDetail: function (id) {
      this.$store.dispatch("prices/duplicateDetail", id);
    },
    gotoDetail: function (id) {
      this.$router.push({
        name: "PricesDetail",
        params: {
          Pid: id,
          title: `Chi tiết bảng giá (#${id})`,
        },
      });
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$router.push({
        name: "PricesDetail",
        params: {
          Pid: "tao-moi",
          title: `Tạo mới bảng giá`,
        },
      });
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    onLogView: function() {
      this.$store.dispatch("priceLog/getList", this.log_pagination);
      setTimeout(() => {this.dialogLogView = true}, 200);
    },
  },
  mounted() {
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_OTHER_ACTION", this.onLogView);
    this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
      this.$store.dispatch("prices/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_OTHER_ACTION", this.onLogView);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  },
};
</script>
